<template>
  <BLayoutExpansion title="Основное">
    <v-row dense>
      <v-col sm="12" lg="6">
        <BTextarea
          v-model="form.name"
          validate="required"
          label="Название"
          :disabled="disabled"
          :skeleton="skeleton"
          :rows="1"
          name="name"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col sm="12" lg="6">
        <BTextarea
          v-model="form.description"
          label="Описание"
          :disabled="disabled"
          :skeleton="skeleton"
          :max-counter="500"
          :rows="2"
          name="description"
        />
      </v-col>
    </v-row>

    <v-row v-if="!isCreate" dense>
      <v-col :cols="!skeleton && 'auto'">
        <BTextField
          :value="form.created_at | dateFormatter"
          :skeleton="skeleton"
          label="Создан"
          disabled
        />
      </v-col>

      <v-col :cols="!skeleton && 'auto'">
        <BTextField
          :value="form.updated_at | dateFormatter"
          :skeleton="skeleton"
          label="Обновлен"
          disabled
        />
      </v-col>
    </v-row>
  </BLayoutExpansion>
</template>

<script>
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BTextarea from '@/components/forms/BTextarea.vue'


export default {
  name: 'FormTemplatesFormMain',
  components: {
    BLayoutExpansion,
    BTextField,
    BTextarea,
  },
  props: {
    skeleton: Boolean,
    disabled: Boolean,
    isCreate: Boolean,
    form: {
      type: Object,
      required: true,
    },
  },
}
</script>
